import { z } from "zod";
import { ManualCfrStatusValidation } from "@/lib/api/cfr";
import { MimeType } from "@/lib/api/utils";

export const ManualCfrPdfValidation = z
  .instanceof(File, { message: "Select a PDF file" })
  .refine((file: File) => file.name.toLocaleLowerCase().endsWith(".pdf"), {
    message: "The selected file must have a .pdf filename",
  })
  .refine(
    (file: File) => file.type === MimeType.Pdf,
    { message: "The selected file must be a PDF" },
  );

const OptionalManualCfrFormTextValidation = z.string().trim().optional();

export const ManualCfrUploadFormValidation = z.object({
  template_id: z.string().uuid("Select a template"),
  customer_id: z.string().uuid("Select a customer"),
  last_status: ManualCfrStatusValidation,
  document_title: OptionalManualCfrFormTextValidation,
  contract_number: OptionalManualCfrFormTextValidation,
  contract_type: OptionalManualCfrFormTextValidation,
  contract_quantity: OptionalManualCfrFormTextValidation,
  contract_shipping_dates: OptionalManualCfrFormTextValidation,
  contract_date: OptionalManualCfrFormTextValidation,
  final_document: ManualCfrPdfValidation,
  sent_document: ManualCfrPdfValidation.nullable(),
});

export type ManualCfrUploadForm = z.infer<typeof ManualCfrUploadFormValidation>;
